import { Link } from "react-router-dom";
import { Activity, BookOpen, Building2 } from "lucide-react";

/**
 * The B2B landing page — a chooser between the section's three areas, nothing else.
 * The External API dashboard (client counters, usage, settings, recent changes) lives
 * one level down, on its own page.
 */
export default function B2bIndex() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">B2B</h1>
        <p className="text-sm text-muted-foreground">Choose an area</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        <AreaCard
          to="/dashboard/b2b/external-api"
          icon={Building2}
          title="External API"
          description="API clients, usage, settings and the change log"
        />
        <AreaCard
          to="/dashboard/b2b/catalog"
          icon={BookOpen}
          title="Docs"
          description="Endpoints, their products, and the documentation behind docs.tipranks.com"
        />
        <AreaCard
          to="/dashboard/b2b/widgets"
          icon={Activity}
          title="Widget"
          description="Health of every production widget page, checked every 30 minutes"
        />
      </div>
    </div>
  );
}

function AreaCard({
  to,
  icon: Icon,
  title,
  description,
}: {
  to: string;
  icon: typeof Building2;
  title: string;
  description: string;
}) {
  return (
    <Link
      to={to}
      className="group flex flex-col rounded-xl border bg-card p-6 transition-all hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5"
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="mb-1 text-lg font-semibold">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </Link>
  );
}
